import createSvgIcon from "@ixigo/icons/utils/createSvgIcon";

export const RightStar = createSvgIcon(
  <svg
    width="28"
    height="14"
    viewBox="0 0 28 14"
    fill="none"
    transform="translate(0,5)"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 0.5L7.33651 6.16349L13 7L7.33651 7.83651L6.5 13.5L5.66349 7.83651L0 7L5.66349 6.16349L6.5 0.5Z"
      fill="#FAFAFA"
    />
    <rect
      x="9"
      y="6.5"
      width="19"
      height="1"
      fill="url(#paint0_linear_5113_66914)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5113_66914"
        x1="9"
        y1="7"
        x2="28"
        y2="7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,

  "RightStar"
);
